import React, {useEffect,useState,useRef} from 'react'
import axios from 'axios';


import Nav from 'react-bootstrap/Nav';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import ReactToPrint from 'react-to-print';
import {useAuthUser} from 'react-auth-kit'

const Palayoffs = () => {
   

  const auth = useAuthUser();  


 
  
  useEffect( () => {
    
    

    alldist();
   
  }, []); 
  

  const [user, setUser] = useState([]);


  const alldist = async () => {
    
  
    try {
  
      
      axios.get(`https://diamond.future-swift.com/api/dist.php`)
      .then(res => {
       
        setUser(res.data.productlist.productdata);
      })
    } catch (error) { throw error;}    
  
  }



  const handleSelect = (eventKey) =>{
    localStorage.setItem('dist',eventKey);
    setClientinf([]);
    setClientinf1([]);
    clientinfo(eventKey);
    clientinfo1(eventKey)
    clientinfo2(eventKey)
  } 
  
  




  const [clientinf, setClientinf] = useState([]);
  
  const [clientinf1, setClientinf1] = useState([]);

  const [clientinf2, setClientinf2] = useState([]);
 



   
  
    const [loading, setLoading] = useState(false);
  const clientinfo = async (id) => {
    
    setLoading(true);
    try {
     
     
      const username =  auth().username;
      const key = auth().key;
  
      axios.get(`https://diamond.future-swift.com/api/playoffs.php?key=`+key+`&username=`+username+`&id=`+id)
      .then(res => {
        
        setClientinf(res.data.productlist.productdata);
      
        

      
      })
   
    } catch (error) { throw error;}    
    finally{
      setTimeout(() => {
        setLoading(false);
      }, 400);
    }  
  }




  const clientinfo1 = async (id) => {
  
    try {
     
     
      
      const username =  auth().username;
    const key = auth().key;
  
      axios.get(`https://diamond.future-swift.com/api/playoffs1.php?key=`+key+`&username=`+username+'&id='+id)
      .then(res => {
        
        setClientinf1(res.data.productlist.productdata);

      })
   
    } catch (error) { throw error;}    
    
  }



  const clientinfo2 = async (id) => {
  
    try {
     
     
      
      const username =  auth().username;
    const key = auth().key;
  
      axios.get(`https://diamond.future-swift.com/api/play_off.php?key=`+key+`&username=`+username+'&id='+id)
      .then(res => {
        
        setClientinf2(res.data.productlist.productdata);

      })
   
    } catch (error) { throw error;}    
    
  }






  



  var nf = new Intl.NumberFormat();


  const tableRef = useRef(null);
  const tableRef1 = useRef(null);

  
  var d=0;
  var c=0;
  var b=0;
  var i=0;
  return (
    
    <div>
    
    <h1>التصفيات</h1>
    
   
    <br /> <br />
    {loading ? (
        <div className="loader-container">
      	  <div className="spinner"></div>
        </div>
        
      ) : ( <div>

   
        <Nav   fill variant="tabs"  defaultActiveKey={localStorage.getItem('dist')} onSelect={handleSelect}>
   
    {user.map((user,index)=>( 
      
        <Nav.Item>
          <Nav.Link eventKey={user.id}>{user.name}</Nav.Link>
        </Nav.Item>
        
        
        ))}
       
      </Nav>
      <br/><br/>
   

   <div className='container2'>
    
    <div className='container1'>
    <DownloadTableExcel 
                    filename="client"
                    sheet="العميل"
                    currentTableRef={tableRef.current}
                >

                   <button id='excel'> Export excel </button>

                </DownloadTableExcel>
                <ReactToPrint
        trigger={() => <button id='pdf'> Print pdf </button>}
        content={() => tableRef.current}
      />
    <table class="table" ref={tableRef}>

    <thead>

    <tr>
 
  
    <th scope="col">التاريخ</th>
    <th scope="col">الصندوق</th>
    <th scope="col">الصرف لاجل</th>
    <th scope="col">المبلغ</th>
    <th scope="col">الموزع</th>
    <th scope="col">لحساب</th>
    <th scope="col">رقم الحساب</th>
    <th scope="col">العملية رقم</th>
    <th scope="col">#</th>
    
  
        </tr>
        </thead>
  <tbody>
    {clientinf1.map((item,index)=>(

        <tr>
      <td className='hide' >{b += Number(item.total) } </td>
        <td>{item.date1}</td> 
        <td>{item.admin_name1}</td>
        <td>{item.reason} </td> 
        <td>{nf.format(item.total)} </td>
        <td>{item.dist}</td>
        <td>{item.emp_name}</td>
        <td>{item.emp_id}</td>
        <td>{item.out_id}</td>
        <th scope="row">{i+=1}</th>	
        
        
       </tr>
     
              
  ))}
</tbody>
  
 <tfoot>
 
 <tr>
  <td colSpan={8}><b>{ nf.format(Number(b))}</b></td>
  <th  scope="row">اجمالي المصروفات</th>
  </tr>

  
  </tfoot>
  </table>
  </div>
     
    <div className='container1'>
    <DownloadTableExcel 
                    filename="client"
                    sheet="العميل"
                    currentTableRef={tableRef1.current}
                >

                   <button id='excel'> Export excel </button>

                </DownloadTableExcel>
                <ReactToPrint
        trigger={() => <button id='pdf'> Print pdf </button>}
        content={() => tableRef1.current}
      />
    <table  class="table" ref={tableRef1}>

    <thead>

    <tr>
 
    
    <th scope="col">التاريخ</th>
    <th scope="col">المستخدم</th>
    <th scope="col">الوارد</th>
    <th scope="col">الموزع</th>
    <th scope="col">لحساب</th>
    <th scope="col">رقم الحساب</th>
    <th scope="col">#</th>
    
    
   
    
       
   
   
  
        </tr>
        </thead>
  <tbody>
    {clientinf.map((item,index)=>(
      

        <tr>
        <td className='hide' >{c += Number(item.paid) } </td>
        <td>{item.date}</td> 
        <td>{item.admin_name}</td> 
        <td>{ nf.format(item.paid)} </td>
        <td>{item.dist}</td>
        <td>{item.client_name}</td>
        <td>{item.client_id}</td>
       
        <th scope="row">{i+=1}</th>	
        
       </tr>
     
              
  ))}
</tbody>
  
 <tfoot>
 <tr>
 <td colSpan={6}><b>{ nf.format(Number(c))}</b></td>
  <th  scope="row">اجمالي الايرادات</th>
  </tr>
  

  
  </tfoot>
  </table>

  
  </div>
 

  </div>


  <div className='container1'>
    <DownloadTableExcel 
                    filename="dist"
                    sheet="الموزع"
                    currentTableRef={tableRef1.current}
                >

                   <button id='excel'> Export excel </button>

                </DownloadTableExcel>
                <ReactToPrint
        trigger={() => <button id='pdf'> Print pdf </button>}
        content={() => tableRef1.current}
      />
    <table  class="table" ref={tableRef1}>

    <thead>

    <tr>
 
    
    <th scope="col">التاريخ</th>
    <th scope="col">الصندوق</th>
    <th scope="col">المبلغ المستلم</th>
    <th scope="col">الموزع</th>
    <th scope="col">#</th>
    
        </tr>
        </thead>
  <tbody>
    {clientinf2.map((item,index)=>(
      

        <tr>
        <td className='hide' >{d += Number(item.total) } </td>
        <td>{item.date}</td> 
        <td>{item.admin_name}</td> 
        <td>{ nf.format(item.total)} </td>
        <td>{item.dist}</td>
        <th scope="row">{i+=1}</th>	
        
       </tr>
     
              
  ))}
</tbody>
  
 <tfoot>
 <tr>
 <td colSpan={5}><b>{ nf.format(Number(d))}</b></td>
  <th  scope="row">اجمالي الايرادات</th>
  </tr>
  

  
  </tfoot>
  </table>



  
  </div>
  <hr></hr>
{ <div style={{color: Number(c)-Number(b+d) > 0 ? "red" : "green"}}>
  
<label htmlFor="">الحالة : {Number(c)-Number(b+d) > 0 ? "غير مصفي" :"مصفي"}</label>  
   <br></br>
    <label htmlFor="">اجمالي الايرادات = {nf.format(Number(c))}</label>  
   <br></br>
    <label htmlFor="">اجمالي المصروفات = {nf.format(Number(b))}</label>  
    <br /> <br />
    <label htmlFor="">اجمالي المبلغ المستلم = {nf.format(Number(d))}</label>  
    <br /> <br />
    <label htmlFor="">المتبقي = {nf.format(Number(c)-Number(b+d))}</label>  
<hr></hr>
    </div>
}
  </div>
 )}

    </div>
  )
  }
  

export default Palayoffs ;









